import {
  computed,
  Inject,
  inject,
  Injectable,
  PLATFORM_ID,
  signal,
} from '@angular/core';
import { AppService } from './app.service';
import { APIConstant } from '../constants/APIConstants';
import { IRegisterGuestProps } from '../models';
import { lastValueFrom } from 'rxjs';
import { ObjectLiteral } from '../models/ObjectLiteral';
import { LocalService } from './local.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private appService = inject(AppService);
  private localService = inject(LocalService);
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    const user = this.localService.getData('son_user');
    const uid = this.localService.getData('son_uid');

    if (user) {
      this.userData.set(user);
    }
    this.uid.set(uid);
  }

  userData = signal(null);

  hasValidToken = (): boolean => {
    if (isPlatformBrowser(this.platformId)) {
      // do stuff, return true or false
      const user = this.localService.getData('son_user');
      if (!user) return false;
      return true;
    }
    return null; // >>>>>>>>>>>>>>>>>>>>>> needed to add this!
  };

  uid = signal(null);
  setUserData(arg) {
    this.userData.set(arg);
    this.localService.saveData('son_user', JSON.stringify(arg));
  }
  setUserId(arg) {
    this.uid.set(arg);
    this.localService.saveData('son_uid', JSON.stringify(arg));
  }
  setPreRegData(arg) {
    this.localService.saveData('son_prereg', JSON.stringify(arg));
  }

  getPreRegData() {
    const data = this.localService.getData('son_prereg');

    if (!data) {
      return null;
    }
    return data;
  }
  getUserData() {
    const user = this.localService.getData('son_user');

    if (!user) {
      return null;
    }
    this.userData.set(user);
    return user;
  }

  isLoggedInSignal = computed(() => {
    return !!this.userData();
  });

  get isLoggedIn() {
    return !!this.userData();
  }

  get userRole() {
    return this.userData()?.roles?.[0];
  }

  clearUserData() {
    console.log('CLEARED~!!!!!!!');
    this.userData.set(null);
    this.localService.clearData();
  }

  login(data: ObjectLiteral) {
    return lastValueFrom(
      this.appService.post(`${APIConstant.auth.login}`, data)
    );
  }

  resetPasswordRequest(data: { email: string }) {
    return lastValueFrom(
      this.appService.post(`${APIConstant.auth.sendPasswordResetEmail}`, data)
    );
  }

  resetPassword(data: {
    password: string;
    confirmPassword: string;
    token: string;
  }) {
    return lastValueFrom(
      this.appService.put(`${APIConstant.auth.resetPassword}`, data)
    );
  }

  verifyEmail(token: string) {
    return lastValueFrom(
      this.appService.get(`${APIConstant.auth.verifyEmail}`, { token })
    );
  }

  register(data: ObjectLiteral): Promise<any> {
    return lastValueFrom(
      this.appService.post(`${APIConstant.auth.register}`, data)
    );
  }
  registerGuest(data: IRegisterGuestProps): Promise<any> {
    return lastValueFrom(
      this.appService.post(`${APIConstant.auth.registerGuest}`, data)
    );
  }

  changePassword(data: {
    password: string;
    confirmPassword: string;
    oldPassword: string;
  }) {
    return this.appService.put(`${APIConstant.auth.changePassword}`, data);
  }
}
